export const categories = [
  { slug: 'football', name: '足球', nameEn: 'Football', icon: 'ri-football-line', color: 'primary', description: '汇聚欧洲五大联赛、世界杯、欧冠等顶级足球赛事直播与资讯' },
  { slug: 'basketball', name: '篮球', nameEn: 'Basketball', icon: 'ri-basketball-line', color: 'accent', description: 'NBA、CBA、欧洲篮球联赛等全球篮球赛事全覆盖' },
  { slug: 'esports', name: '电竞', nameEn: 'Esports', icon: 'ri-gamepad-line', color: 'primary', description: 'LOL、DOTA2、CS2、王者荣耀等顶级电竞赛事直播' },
  { slug: 'tennis', name: '网球', nameEn: 'Tennis', icon: 'ri-base-station-line', color: 'accent', description: '四大满贯、ATP、WTA巡回赛全程跟踪报道' },
  { slug: 'comprehensive', name: '综合', nameEn: 'Comprehensive', icon: 'ri-medal-line', color: 'primary', description: '田径、游泳、拳击、赛车等综合体育赛事一网打尽' },
];

export const liveMatches = [
  {
    id: 'match-1',
    category: 'football',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    minute: '72\'',
    league: '西甲联赛',
    viewers: 1280000,
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20football%20soccer%20stadium%20at%20night%20with%20dramatic%20stadium%20lights%2C%20green%20pitch%2C%20packed%20crowd%2C%20intense%20match%20atmosphere%2C%20sports%20photography%20style%2C%20professional%20lighting%2C%20clean%20composition&width=800&height=450&seq=match-football-elclasico&orientation=landscape',
  },
  {
    id: 'match-2',
    category: 'basketball',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeScore: 98,
    awayScore: 95,
    status: 'live',
    minute: 'Q4 3:21',
    league: 'NBA常规赛',
    viewers: 980000,
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20in%20modern%20indoor%20arena%2C%20players%20in%20action%20on%20polished%20wooden%20court%2C%20bright%20arena%20lights%2C%20packed%20stadium%2C%20dynamic%20sports%20moment%2C%20clean%20composition&width=800&height=450&seq=match-basketball-nba&orientation=landscape',
  },
  {
    id: 'match-3',
    category: 'esports',
    homeTeam: 'T1',
    awayTeam: 'JDG',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    minute: 'BO5 G4',
    league: 'LOL全球总决赛',
    viewers: 2560000,
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20esports%20arena%20with%20massive%20LED%20screens%2C%20professional%20gaming%20stage%20with%20colorful%20lights%2C%20two%20teams%20competing%2C%20huge%20enthusiastic%20crowd%2C%20modern%20stadium%2C%20cinematic%20lighting&width=800&height=450&seq=match-esports-lol&orientation=landscape',
  },
  {
    id: 'match-4',
    category: 'tennis',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeScore: 2,
    awayScore: 1,
    status: 'upcoming',
    minute: '今日 20:00',
    league: '温网男单决赛',
    viewers: 0,
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20on%20grass%20court%2C%20Wimbledon%20style%2C%20elegant%20stadium%20with%20clear%20blue%20sky%2C%20two%20players%20in%20white%20attire%2C%20tennis%20net%20in%20foreground%2C%20clean%20sports%20photography&width=800&height=450&seq=match-tennis-wimbledon&orientation=landscape',
  },
  {
    id: 'match-5',
    category: 'football',
    homeTeam: '曼彻斯特城',
    awayTeam: '阿森纳',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    minute: '明日 03:00',
    league: '英超联赛',
    viewers: 0,
    thumbnail: 'https://readdy.ai/api/search-image?query=Premier%20League%20football%20stadium%20with%20bright%20green%20pitch%2C%20modern%20arena%20architecture%2C%20clear%20daylight%2C%20professional%20soccer%20atmosphere%2C%20wide%20angle%20view%2C%20clean%20composition&width=800&height=450&seq=match-football-premier&orientation=landscape',
  },
  {
    id: 'match-6',
    category: 'basketball',
    homeTeam: '广东宏远',
    awayTeam: '辽宁本钢',
    homeScore: 102,
    awayScore: 99,
    status: 'finished',
    minute: '已结束',
    league: 'CBA常规赛',
    viewers: 520000,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20basketball%20league%20game%20in%20large%20indoor%20arena%2C%20players%20dribbling%20on%20court%2C%20excited%20fans%20in%20stands%2C%20bright%20modern%20lighting%2C%20professional%20sports%20photography&width=800&height=450&seq=match-basketball-cba&orientation=landscape',
  },
];

export const newsArticles = [
  {
    id: 'news-1',
    title: '欧冠决赛前瞻：皇马vs巴萨，谁能问鼎欧洲之巅',
    excerpt: '本赛季欧冠决赛即将上演西班牙国家德比，皇家马德里与巴塞罗那将在温布利大球场展开巅峰对决。本文将从战术、阵容、历史交锋等多个维度进行深度分析。',
    category: 'football',
    categoryName: '足球',
    author: '体育观察员',
    date: '2026-08-09',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=UEFA%20Champions%20League%20trophy%20on%20pedestal%20with%20dramatic%20stadium%20lighting%20background%2C%20premium%20sports%20editorial%20photography%2C%20golden%20and%20white%20color%20palette%2C%20clean%20professional%20look&width=600&height=400&seq=news-ucl-final&orientation=landscape',
    content: `<p>2025-2026赛季欧洲冠军联赛即将迎来最终决战，皇家马德里与巴塞罗那这两支西甲豪门将在伦敦温布利大球场为欧洲足坛最高荣誉展开争夺。</p>
    <p>皇马在本赛季欧冠赛场上展现出强大的统治力，从小组赛到淘汰赛一路过关斩将，先后击败了拜仁慕尼黑、曼城等强敌。安切洛蒂的战术体系在本赛季愈发成熟，维尼修斯和姆巴佩的双前锋组合令所有防线胆寒。</p>
    <p>巴萨方面，在哈维的带领下球队展现出了令人耳目一新的传控足球。佩德里、加维等年轻中场球员的成长让巴萨的中场控制力重回巅峰。莱万多夫斯基虽然年事已高，但依然保持着极高的进球效率。</p>
    <p>从历史交锋来看，两队在本赛季西甲联赛中各胜一场，实力旗鼓相当。本场决赛的关键在于中场的争夺——谁能控制中场，谁就能掌握比赛的主动权。</p>
    <p>无论最终谁能捧起大耳朵杯，这场西班牙国家德比版的欧冠决赛注定将成为足球史上的经典之战。</p>`,
  },
  {
    id: 'news-2',
    title: 'NBA休赛期重磅交易：超级巨星换队震动联盟格局',
    excerpt: 'NBA休赛期交易市场风起云涌，多位全明星球员改换门庭，联盟格局发生重大变化。本文为你梳理今夏最值得关注的交易动态。',
    category: 'basketball',
    categoryName: '篮球',
    author: '篮坛观察家',
    date: '2026-08-08',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20arena%20with%20dramatic%20spotlight%20on%20center%20court%2C%20empty%20court%20with%20atmospheric%20lighting%2C%20professional%20sports%20photography%2C%20dark%20background%20with%20court%20lines%20illuminated&width=600&height=400&seq=news-nba-trade&orientation=landscape',
    content: `<p>2026年NBA休赛期的交易市场堪称近年来最为活跃的一季。多位全明星级别球员的转会彻底改变了联盟的力量版图。</p>
    <p>最引人注目的当属卢卡·东契奇的交易，这位斯洛文尼亚超级巨星在效力独行侠多年后选择加盟纽约尼克斯，为麦迪逊花园球场带来了久违的超级巨星。</p>
    <p>卫冕冠军波士顿凯尔特人也在积极补强阵容，他们通过一系列操作引进了多位优质角色球员，志在卫冕。</p>
    <p>西部方面，雷霆队通过选秀和交易继续囤积天赋，他们的年轻核心阵容让人对未来充满期待。而勇士队在经历了上赛季的低迷后，也在今夏进行了大刀阔斧的调整。</p>`,
  },
  {
    id: 'news-3',
    title: 'LOL全球总决赛：LPL赛区四支战队出征，剑指冠军',
    excerpt: '2026英雄联盟全球总决赛即将拉开帷幕，LPL赛区派出四支顶尖战队出征。本文深度分析各队实力与夺冠前景。',
    category: 'esports',
    categoryName: '电竞',
    author: '电竞先锋',
    date: '2026-08-07',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Epic%20esports%20stadium%20stage%20with%20five%20gaming%20chairs%20under%20spotlights%2C%20massive%20LED%20screens%20displaying%20game%20footage%2C%20purple%20and%20gold%20lighting%2C%20professional%20tournament%20setup&width=600&height=400&seq=news-lol-worlds&orientation=landscape',
    content: `<p>2026英雄联盟全球总决赛的战鼓即将擂响，来自LPL赛区的四支战队已经整装待发，准备向召唤师杯发起冲击。</p>
    <p>作为卫冕冠军，BLG战队在本赛季延续了出色的竞技状态，上单Bin和中单Knight的发挥依旧是队伍最稳定的输出点。他们将是本届赛事最大的夺冠热门之一。</p>
    <p>JDG战队在引进新人打野后焕发了新的活力，整体战术体系更加多元化。TES和WBG同样具备冲击冠军的实力，LPL赛区整体竞争力不容小觑。</p>
    <p>韩国LCK赛区的T1和GEN依旧是LPL最强的对手，欧美赛区的崛起也不容忽视。本届全球总决赛的竞争将空前激烈。</p>`,
  },
  {
    id: 'news-4',
    title: '温网男单决赛：新老天王巅峰对决引爆网坛',
    excerpt: '温布尔登网球锦标赛男单决赛，德约科维奇与阿尔卡拉斯再度狭路相逢，这场比赛将决定谁才是当今网坛的王者。',
    category: 'tennis',
    categoryName: '网球',
    author: '网球之声',
    date: '2026-08-06',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20championship%20trophy%20on%20grass%20court%2C%20elegant%20summer%20setting%20with%20green%20and%20purple%20branding%2C%20premium%20sports%20photography%2C%20clean%20classic%20composition&width=600&height=400&seq=news-tennis-wimbledon&orientation=landscape',
    content: `<p>2026年温布尔登网球锦标赛男单决赛的对阵双方已经产生——塞尔维亚天王诺瓦克·德约科维奇与西班牙新星卡洛斯·阿尔卡拉斯。</p>
    <p>这是两人继2023年和2024年温网决赛后，第三次在全英俱乐部上演巅峰对决。前两次交手各胜一场，此番再度相遇，悬念十足。</p>
    <p>德约科维奇本赛季状态依然火热，他在半决赛中以直落三盘的方式击败了辛纳，展现出了令人惊叹的草地实力。而阿尔卡拉斯则在另一场半决赛中苦战五盘逆转梅德韦杰夫，体能消耗较大。</p>
    <p>这场新老天王的较量不仅是技术的比拼，更是意志力的较量。究竟是德约科维奇再添一座大满贯，还是阿尔卡拉斯新王登基，让我们拭目以待。</p>`,
  },
  {
    id: 'news-5',
    title: '2026世界杯预选赛：中国队关键战役即将打响',
    excerpt: '中国男足国家队即将迎来世界杯预选赛亚洲区18强赛的关键战役，球队备战情况与出线形势全面分析。',
    category: 'football',
    categoryName: '足球',
    author: '中国足球报道',
    date: '2026-08-05',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20on%20pitch%20in%20red%20jerseys%2C%20professional%20soccer%20stadium%2C%20team%20huddle%20moment%2C%20bright%20daylight%2C%20sports%20journalism%20photography&width=600&height=400&seq=news-china-football&orientation=landscape',
    content: `<p>中国男足国家队即将在世界杯预选赛亚洲区18强赛中迎来关键战役。目前中国队在小组中排名第四，距离直接出线区仅差3分。</p>
    <p>主教练在赛前发布会上表示，球队已经做好了充分的准备。新任归化球员的加入让球队的整体实力有了明显提升，特别是在进攻端的变化更多了。</p>
    <p>本场比赛中国队将在主场迎战小组第二的澳大利亚队。如果能够全取三分，中国队的出线形势将大为改观。全国球迷都在期待着这场生死之战。</p>`,
  },
  {
    id: 'news-6',
    title: 'F1新加坡大奖赛：夜间街道赛的速度与激情',
    excerpt: 'F1新加坡大奖赛作为赛季唯一的夜间街道赛，以其独特的魅力和极具挑战性的赛道设计吸引着全球车迷的目光。',
    category: 'comprehensive',
    categoryName: '综合',
    author: '赛车世界',
    date: '2026-08-04',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20on%20night%20street%20circuit%20with%20city%20lights%20and%20illuminated%20track%2C%20motion%20blur%20effect%2C%20dramatic%20lighting%2C%20Singapore%20skyline%20background&width=600&height=400&seq=news-f1-singapore&orientation=landscape',
    content: `<p>F1新加坡大奖赛作为赛历上唯一的全夜间街道赛，一直以来都是赛季中最具观赏性的分站赛之一。</p>
    <p>滨海湾街道赛道全长5.063公里，拥有23个弯道，是赛历中弯道数量最多的赛道之一。高温高湿的环境加上夜间的灯光照明，对车手的体能和专注力都是极大的考验。</p>
    <p>本赛季的冠军争夺已经进入白热化阶段，维斯塔潘、勒克莱尔和诺里斯三位车手在积分榜上交替领先。新加坡站的结果可能将对最终的冠军归属产生决定性影响。</p>`,
  },
];

export const platformStats = [
  { label: '全球注册用户', value: '5,800万+', icon: 'ri-user-star-line' },
  { label: '覆盖赛事', value: '200+', icon: 'ri-global-line' },
  { label: '年直播场次', value: '50,000+', icon: 'ri-live-line' },
  { label: '合作体育机构', value: '300+', icon: 'ri-team-line' },
];

export const faqs = [
  {
    question: '米乐体育平台是否免费使用？',
    answer: '米乐体育平台提供免费注册和基础观赛服务。用户注册后即可免费观看大部分赛事直播。部分高级赛事和高清画质服务可选择成为VIP会员享受更优质的观赛体验。',
  },
  {
    question: '如何注册米乐体育账号？',
    answer: '注册非常简单！点击网站右上角的"注册"按钮，填写手机号码或邮箱地址，设置密码后即可完成注册。也可以通过微信、QQ等第三方账号一键登录。',
  },
  {
    question: '米乐体育支持哪些设备观看？',
    answer: '米乐体育支持全平台观看，包括PC网页端、iOS App、Android App以及平板设备。所有平台数据同步，让您随时随地畅享体育赛事。',
  },
  {
    question: '直播画质如何？是否支持回放？',
    answer: '米乐体育提供最高4K超高清画质直播，自适应网络状况调整清晰度。大部分赛事均支持7天内回放功能，错过直播再也不怕。',
  },
  {
    question: '平台上的赛事数据是否实时更新？',
    answer: '是的，米乐体育采用先进的实时数据推送技术，所有赛事比分、统计数据和比赛动态均与现场同步更新，延迟不超过3秒，确保您获得最及时的赛事信息。',
  },
  {
    question: '如何联系米乐体育客服？',
    answer: '您可以通过在线客服（7x24小时）、官方邮箱service@milesports.com或拨打客服热线400-888-6666联系我们。VIP会员还享有专属客服通道。',
  },
];

export const brandMilestones = [
  { year: '2018', title: '品牌创立', description: '米乐体育正式成立，以"让体育更精彩"为使命，开启体育娱乐新篇章' },
  { year: '2019', title: '赛事版权拓展', description: '获得五大联赛及NBA赛事版权，平台内容生态初步建立' },
  { year: '2020', title: '用户突破千万', description: '注册用户数突破1000万，成为国内增长最快的体育平台之一' },
  { year: '2021', title: '技术升级', description: '全面升级直播技术，支持4K超高清画质和多屏同看功能' },
  { year: '2022', title: '国际化布局', description: '业务拓展至东南亚、中东市场，服务全球体育爱好者' },
  { year: '2023', title: '用户突破5000万', description: '全球注册用户突破5000万，月活跃用户超2000万' },
  { year: '2024', title: 'AI数据平台', description: '推出AI驱动的赛事数据分析系统，为球迷提供深度赛事洞察' },
  { year: '2025', title: '行业领军', description: '荣获多项行业大奖，被评为最具影响力体育科技平台' },
];

export const contactInfo = {
  phone: '400-888-6666',
  email: 'service@milesports.com',
  address: '北京市朝阳区建国路88号SOHO现代城A座18层',
  workingHours: '周一至周日 9:00 - 21:00',
};